export const StepImg = ({imgUrl, text, offset, opacity}) => {
    if (!opacity) {
        opacity = 0
    }
    return (
        <img src={imgUrl} alt={text} style={{top: offset + 'px', left: offset + 'px', opacity: opacity}} className={'step__image'}/>
    )
}